<div class="d-flex mt-2 pl-2">
<!-- </div>
<div class="d-flex justify-content-end mt-n4"> -->
  @if (!isView) {
    <button type="button" class="primary-btn" (click)="openModalPopup()">
      <span>{{'button.add' | translate | async }}</span>
      <i class="fa fa-plus-circle"></i>
    </button>
  }
</div>

@if (question.gridData && question.gridData.length > 0 && fields.length > 0) {
  <div class="kx-control col-12 col-lg-12 fix p-0">
    <dhs-data-grid [data]="{'resource':question.gridData}"
      [fields]="fields" [config]="dataGridConfig" (editEllipseClick)="modifyForm($event)">
    </dhs-data-grid>
  </div>
}